module.exports = __webpack_public_path__ + "assets/img/teacher (8).abaf8994.png";